var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRouteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1498_24754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.58366 4.16663H9.94566C12.485 4.16663 13.7547 4.16663 14.2367 4.6227C14.6533 5.01693 14.8379 5.59769 14.7255 6.16014C14.5953 6.81081 13.5587 7.54401 11.4856 9.0104L8.09843 11.4062C6.02525 12.8726 4.98865 13.6058 4.85852 14.2565C4.74604 14.8189 4.93067 15.3997 5.34729 15.7939C5.82927 16.25 7.09896 16.25 9.63833 16.25H10.417M6.66699 4.16663C6.66699 5.54734 5.5477 6.66663 4.16699 6.66663C2.78628 6.66663 1.66699 5.54734 1.66699 4.16663C1.66699 2.78591 2.78628 1.66663 4.16699 1.66663C5.5477 1.66663 6.66699 2.78591 6.66699 4.16663ZM18.3337 15.8333C18.3337 17.214 17.2144 18.3333 15.8337 18.3333C14.4529 18.3333 13.3337 17.214 13.3337 15.8333C13.3337 14.4526 14.4529 13.3333 15.8337 13.3333C17.2144 13.3333 18.3337 14.4526 18.3337 15.8333Z",
    stroke: "#C4B9ED",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1498_24754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouteIcon);
export default __webpack_public_path__ + "static/media/route-icon.ad1a87964ca05e76a42b1195301a79ca.svg";
export { ForwardRef as ReactComponent };